import { cellRenderPopupActM1 } from '../../PopupActMVP/functionPopupAct';
import {
  cellRenderParseData,
  cellRenderStatusAct
} from '../../../utils/functions';

const columnDataMX1 = [
  {
    dataField: 'documentId',
    caption: 'МХ-1',
    cellRender: cellRenderPopupActM1,
    cssClass: 'td-button-cell-render',
    dataType: 'string'
  },
  {
    dataField: 'mh1NumId',
    caption: 'id МХ-1',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'mh1DocStatus',
    caption: 'id МХ-1 Doc Status',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'mh1Date',
    caption: 'Дата МХ-1',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'mh1DocStatusDescr',
    caption: 'Статус акта МХ-1',
    cellRender: cellRenderStatusAct,
    dataType: 'string'
  },
  {
    dataField: 'departureDate',
    caption: 'Дата убытия баржи',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'cost',
    caption: 'Стоимость',
    dataType: 'number'
  }
];
export default columnDataMX1;
